const CONFIG_URL = "/analytics-config.json";

type AnalyticsRemoteConfig = {
  postHogEnabled: boolean;
};

const DISABLED: AnalyticsRemoteConfig = { postHogEnabled: false };

let cached: Promise<AnalyticsRemoteConfig> | null = null;

/**
 * Runtime on/off, read from a static same-origin file rather than a build-time
 * env var: turning PostHog off is an S3 overwrite plus a CloudFront
 * invalidation, not a rebuild and redeploy. Any failure resolves to disabled.
 */
export const fetchAnalyticsConfig = (): Promise<AnalyticsRemoteConfig> => {
  if (!cached) {
    cached = fetch(CONFIG_URL, { cache: "no-store" })
      .then((res) =>
        res.ok ? (res.json() as Promise<AnalyticsRemoteConfig>) : DISABLED
      )
      .catch(() => DISABLED);
  }
  return cached;
};
